import { SliderHTMLElement } from '../../../../common/slider/slider';

const ATTRIBUTES = [
    'data-autoplay',
    'data-autoplay-interval',
    'data-autoplay-pauseonhover',
    'data-infinite',
    'data-items-count',
    'data-variation',
    'data-edit-mode',
];

export class SliderWithTitleHTMLElement extends SliderHTMLElement {
    constructor() {
        super({
            containerSelector: '.slider-with-title__container--items',
            itemsContainerSelector: '.slider-with-title__items',
            itemSelector: '.slider-with-title__item',
            nextNavSelector: '.slider-with-title__next',
            prevNavSelector: '.slider-with-title__prev'
        });
    }

    static get observedAttributes(): string[] {
        return ATTRIBUTES;
    }

    public attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
        if (!ATTRIBUTES.includes(name)) {
            return;
        }

        if (oldValue === newValue) {
            return;
        }

        super.attributeChangedCallback(name, oldValue, newValue);

        setTimeout(() => {
            switch (name) {
                case 'data-autoplay':
                    this.autoplay = newValue === 'true';
                    this.autoplay ? this.enableAutoplay() : this.disableAutoplay();
                    break;
                case 'data-autoplay-interval':
                    this.autoplayInterval = Number.parseInt(newValue);
                    if (this.autoplay) {
                        this.disableAutoplay();
                        this.enableAutoplay();
                    }
                    break;
                case 'data-autoplay-pauseonhover':
                    this.autoplayPauseOnHover = newValue === 'true'
                    this.autoplayPauseOnHover ? this.enablePauseOnHover() : this.disablePauseOnHover();
                    break;
                case 'data-infinite':
                    this.infinite = newValue === 'true';
                    if (oldValue === 'true') {
                        this.cleanUpInfinite();
                    }
                    if (newValue === 'true') {
                        this.setUpInfinite();
                    }
                    break;
                case 'data-items-count':
                    this.itemsTotal = Number.parseInt(newValue);
                    if (newValue > oldValue) {
                        this.reset();
                    } else {
                        this.reset(this.startingSlideIndex);
                    }
                    break;
                case 'data-variation':
                    this.sliderType = `SliderWithTitle - ${newValue}`
                    if (oldValue !== null) {
                        this.reset(this.startingSlideIndex);
                    }
                    break;
                default:
                    break;
            }
        })
    }
}
